// third-party
import { FormattedMessage } from 'react-intl';

// assets

import {
    IconBrandChrome,
    IconHelp,
    IconSitemap,
    IconCheckbox,
    IconSchool,
    IconEyeCheck,
    IconListDetails,
    IconNotes,
    IconUserPlus
} from '@tabler/icons';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';

// constant
const icons = {
    IconBrandChrome,
    IconHelp,
    IconSitemap,
    IconCheckbox,
    CalendarMonthOutlinedIcon,
    IconSchool,
    IconEyeCheck,
    IconListDetails,
    IconNotes,
    EventOutlinedIcon,
    IconUserPlus
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const other = {
    id: 'other',
    type: 'group',
    children: [
        {
            id: 'calendar',
            title: <FormattedMessage id="calendar" />,
            type: 'item',
            url: '/calendar',
            icon: icons.CalendarMonthOutlinedIcon,
            children: [
                {
                    id: 'session',
                    title: <FormattedMessage id="Lesson Library" />,
                    type: 'item',
                    url: '/session/:sessionId',
                    icon: icons.IconSchool
                }
            ]
        },
        {
            id: 'attendance',
            title: <FormattedMessage id="attendance-page" />,
            type: 'item',
            url: '/attendance',
            icon: icons.IconListDetails
        },
        {
            id: 'library',
            title: <FormattedMessage id="Lesson Library" />,
            type: 'item',
            url: '/lesson-library',
            icon: icons.IconSchool
        },
        {
            id: 'assessments',
            title: <FormattedMessage id="assessments" />,
            type: 'item',
            url: '/assessments',
            icon: icons.IconNotes
        },
        localStorage.roles?.includes('Supervisor')
            ? {
                  id: 'supervisor-review',
                  title: <FormattedMessage id="Supervisor Review" />,
                  type: 'item',
                  url: '/supervisor-review',
                  icon: icons.IconEyeCheck
              }
            : null,
        localStorage.roles?.includes('Supervisor') || localStorage.roles?.includes('Admin')
            ? {
                  id: 'provider-intake',
                  title: <FormattedMessage id="Provider Intake" />,
                  type: 'item',
                  url: '/provider-intake',
                  icon: icons.IconUserPlus
              }
            : null
    ].filter(Boolean)
};

export default other;
